module.exports = __webpack_public_path__ + "c853a4de8d6ebe6b8b611248f306bfa6.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/wings/wave-right-16.png
// module id = 3123
// module chunks = 0